import './laventura/style';
import FormStructure from './laventura/form_structure';

export default FormStructure;